<template>
  <div>
    <quill-editor
      ref="quillEditor"
      v-model="val"
      :options="editorOptions"
      @blur="onEditorBlur"
      @focus="onEditorFocus"
    />
    <!-- مدال برای ویرایش ALT -->
    <b-modal
      v-model="showImageModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="اضافه کردن  alt به تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveImageAlt"
      @cancel="resetModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Alt"
            label-for="Alt"
          >
            <b-form-input
              id="Alt"
              v-model="imageAlt"
              name="Title"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
// import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-better-table/dist/quill-better-table.css';

import {quillEditor, Quill} from 'vue-quill-editor-support-insert-table'
import QuillBetterTable from 'quill-better-table'
Quill.register('modules/better-table', QuillBetterTable)

// ماژول تصویر را سفارشی می‌کنیم
class CustomImageHandler {
  constructor(quill) {
    this.quill = quill
  }

  selectLocalImage() {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/png, image/jpeg, image/gif, image/webp') // اضافه کردن WebP
    input.click()

    input.onchange = () => {
      const file = input.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = () => {
          const range = this.quill.getSelection()
          this.quill.insertEmbed(range.index, 'image', reader.result)
        }
        reader.readAsDataURL(file)
      }
    }
  }
}

export default {
  name: 'ZQuillEditor',
  components: {
    quillEditor,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
              [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
              [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
              [{ direction: 'rtl' }], // text direction
              [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
              ['clean'], // remove formatting button
              ['link', 'image', 'video', 'formula'],
              [{'table': 'TD'}],
            ],
            handlers: {
              image() {
                const imageHandler = new CustomImageHandler(this.quill)
                imageHandler.selectLocalImage()
              },
              table: function () {
                this.quill.getModule('better-table').insertTable(4, 4) // 默认插入4*4的表格
              },
            },

          },
          table: false,
          'better-table': {
            operationMenu: {
              items: {
                insertColumnRight: {
                  text: "Insert Right"
                },
                insertColumnLeft: {
                  text: "Insert Left"
                },
                insertRowUp: {
                  text: "Insert Above"
                },
                insertRowDown: {
                  text: "Insert Below"
                },
                mergeCells: {
                  text: "Merge Cells"
                },
                unmergeCells: {
                  text: "Split Cells"
                },
                deleteColumn: {
                  text: "Delete Column"
                },
                deleteRow: {
                  text: "Delete Row"
                },
                deleteTable: {
                  text: "Delete Table"
                }
              },
              background: {
                color: '#333'
              },
              color: {
                colors: ['green', 'red', 'yellow', 'blue', 'white'],
                text: 'background:'
              }
            }
          },
          keyboard: {
            bindings: QuillBetterTable.keyboardBindings
          }
        },
      },
      showImageModal: false, // وضعیت نمایش مدال
      currentImage: null, // تصویر فعلی که ویرایش می‌شود
      imageAlt: '', // متن ALT
      scrollPosition: 0, // موقعیت اسکرول ویرایشگر
      quillInstance: null, // ارجاع به Quill
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
  mounted() {
    // گوش دادن به رویداد کلیک روی تصویر
    document.addEventListener('click', this.handleImageClick)
  },
  beforeDestroy() {
    // حذف Listener هنگام خروج
    document.removeEventListener('click', this.handleImageClick)
  },
  methods: {
    // باز کردن مدال ویرایش ALT
    handleImageClick(event) {
      if (event.target.tagName === 'IMG' && event.target.closest('div.ql-editor')) {
        this.currentImage = event.target // انتخاب تصویر
        this.imageAlt = this.currentImage.getAttribute('alt') || '' // گرفتن ALT فعلی
        this.showImageModal = true // نمایش مدال
      }
    },

    // ذخیره تغییرات ALT
    saveImageAlt() {
      if (this.currentImage) {
        this.currentImage.setAttribute('alt', this.imageAlt) // اعمال ALT جدید

        this.resetModal()
      }
    },

    // بازنشانی وضعیت مدال
    resetModal() {
      this.showImageModal = false
      this.currentImage = null
      this.imageAlt = ''
    },

    // رویدادهای Editor
    onEditorBlur() {
      console.log('Editor lost focus')
    },
    onEditorFocus() {
      console.log('Editor focused')
    },
  },
}
</script>
<style scoped>

</style>
